<template>
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 490.667 490.667" style="enable-background:new 0 0 490.667 490.667;" xml:space="preserve"
		:style="{
			width: width,
			fill: colour
		}">
	<g>
		<g>
			<path d="M423.531,67.136c-4.16-4.16-10.923-4.16-15.083,0L259.115,216.469c-4.16,4.16-4.16,10.923,0,15.083
				c2.091,2.069,4.821,3.115,7.552,3.115c2.731,0,5.461-1.045,7.531-3.115L423.531,82.219
				C427.691,78.059,427.691,71.296,423.531,67.136z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M416,64c-5.888,0-10.667,4.779-10.667,10.667v128c0,5.888,4.779,10.667,10.667,10.667c5.888,0,10.667-4.779,10.667-10.667
				v-128C426.667,68.779,421.888,64,416,64z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M416,64H288c-5.888,0-10.667,4.779-10.667,10.667S282.112,85.333,288,85.333h128c5.888,0,10.667-4.779,10.667-10.667
				S421.888,64,416,64z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M231.531,259.136c-4.16-4.16-10.923-4.16-15.083,0L67.115,408.469c-4.16,4.16-4.16,10.923,0,15.083
				c2.091,2.069,4.821,3.115,7.552,3.115c2.731,0,5.461-1.045,7.531-3.115l149.333-149.333
				C235.691,270.059,235.691,263.296,231.531,259.136z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M74.667,277.333C68.779,277.333,64,282.112,64,288v128c0,5.888,4.779,10.667,10.667,10.667S85.333,421.888,85.333,416V288
				C85.333,282.112,80.555,277.333,74.667,277.333z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M202.667,405.333h-128C68.779,405.333,64,410.112,64,416c0,5.888,4.779,10.667,10.667,10.667h128
				c5.888,0,10.667-4.779,10.667-10.667C213.333,410.112,208.555,405.333,202.667,405.333z"/>
		</g>
	</g>
	<g>
		<g>
			<path d="M458.667,0H32C14.357,0,0,14.357,0,32v426.667c0,17.643,14.357,32,32,32h426.667c17.643,0,32-14.357,32-32V32
				C490.667,14.357,476.309,0,458.667,0z M469.333,458.667c0,5.867-4.8,10.667-10.667,10.667H32c-5.867,0-10.667-4.8-10.667-10.667
				V32c0-5.867,4.8-10.667,10.667-10.667h426.667c5.867,0,10.667,4.8,10.667,10.667V458.667z"/>
		</g>
	</g>
</svg>
</template>

<script>
import Mixin from './Mixin';

export default {
  mixins: [Mixin],
};
</script>
